import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  .benefits-list {
    margin-top: 36px;
    li {
      display: flex;
      align-items: center;
      width: calc(100% - 22px);
      padding: 10px;
      border: 1px solid var(--grey-3);
      border-radius: 8px;
      margin-bottom: 6px;
      svg {
        margin-right: 10px;
        path {
          fill: var(--success-color);
        }
      }
    }
  }

  h1 {
    font-size: 22px;
    margin-bottom: 3px;
    line-height: 28px;
    margin-left: 0px;
  }

  .interview-offer {
    p {
      font-size: 18px;
      line-height: 1.6em;
      font-weight: 500;
      margin-bottom: 12px;
      color: var(--grey-0);
      text-align: center;
    }
  }

  .subheader {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 32.2808px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    opacity: 0.5;
    text-align: center;
    margin-top: 24px;
  }

  .headline {
    font-family: "GT Super Text";
    font-style: normal;
    font-weight: 400;
    font-size: 38px;
    line-height: 140%;
    text-align: center;
    margin-bottom: 14px;
  }

  .button-row {
    display: flex;
    margin: auto;
    justify-content: center;
    gap: 20px;
    margin-top: 40px;
    scale: 1.2;
  }

  p {
    font-size: 14px;
    color: #888;
    font-weight: normal;
  }
  img {
    width: 50vw;
  }

  .select {
    margin: 15px auto;
  }

  textarea {
    width: 100%;
    border: 1.5px solid var(--grey-2);
    outline: 2.5px solid transparent;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px;
    font-size: 18px;
    margin: 15px auto;
    border-radius: 8px;
    resize: none;

    &:focus {
      border: 1.5px solid transparent;
      outline: 2.5px solid var(--primary-cta-hover);
    }
  }
`;
